import angular from 'angular';

const imageServiceFactory = ($sce) => {
  'ngInject';
  const service = {
    byteArrayToUrl: (arr) => {
        const bytes = new Uint8Array(arr);
        let blob = new Blob([bytes], {type: 'image/png'});
        let fileURL = URL.createObjectURL(blob);
        return fileURL;
    }, 
    byteArrayToBase64 : (arr) => {
      const bytes = new Uint8Array(arr);
      return btoa(new Uint8Array(bytes).reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));
    } 
}

return service;
  
}

export default imageServiceFactory;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/image.factory.js
 **/